// Kontrak nilai hasil POST /api/upload → {path, url}.
//   "path" = storage key internal (default; Categories/Banners/produk → /api/files/<key>)
//   "url"  = URL publik /uploads/<key> (field branding yang di-absolutize SSR:
//            og:image / favicon / logo fallback)
export const UPLOAD_VALUE_FIELDS = ["path", "url"];

export function pickUploadValue(data, valueField = "path") {
  if (!UPLOAD_VALUE_FIELDS.includes(valueField)) {
    throw new Error(`valueField tidak dikenal: ${valueField}`);
  }
  const v = data?.[valueField];
  if (typeof v !== "string" || !v) {
    throw new Error("Upload gagal. Silakan coba kembali.");
  }
  return v;
}
